// Values set annual by CMS and need to be updated every year before AEP (Annual Enrollment Period).

// Part B premiums based on income tier
export const enum IRMAA_PART_B_PREMIUM {
  One = 202.9,
  Two = 284.1,
  Three = 405.8,
  Four = 527.5,
  Five = 649.2,
  Six = 689.9,
}

// Surcharge to add on top of Part D monthly premiums, based on income tiers
export const enum IRMAA_PART_D_SURCHARGE {
  One = 0,
  Two = 14.5,
  Three = 37.5,
  Four = 60.4,
  Five = 83.3,
  Six = 91,
}

export type CostTier = {
  cost: number;
  partD: number;
  low: number;
  high: number;
};

// IRMAA income tiers - tax status is Single (married, filing separately has different tiers)
export const IndividualTiers: CostTier[] = [
  {
    cost: IRMAA_PART_B_PREMIUM.One,
    partD: IRMAA_PART_D_SURCHARGE.One,
    low: 0,
    high: 109000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Two,
    partD: IRMAA_PART_D_SURCHARGE.Two,
    low: 109001,
    high: 137000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Three,
    partD: IRMAA_PART_D_SURCHARGE.Three,
    low: 137001,
    high: 171000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Four,
    partD: IRMAA_PART_D_SURCHARGE.Four,
    low: 171001,
    high: 205000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Five,
    partD: IRMAA_PART_D_SURCHARGE.Five,
    low: 205001,
    high: 500000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Six,
    partD: IRMAA_PART_D_SURCHARGE.Six,
    low: 500001,
    high: 999999999,
  },
];

// IRMAA income tiers
export const MarriedJointlyTiers: CostTier[] = [
  {
    cost: IRMAA_PART_B_PREMIUM.One,
    partD: IRMAA_PART_D_SURCHARGE.One,
    low: 0,
    high: 218000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Two,
    partD: IRMAA_PART_D_SURCHARGE.Two,
    low: 218001,
    high: 274000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Three,
    partD: IRMAA_PART_D_SURCHARGE.Three,
    low: 274001,
    high: 342000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Four,
    partD: IRMAA_PART_D_SURCHARGE.Four,
    low: 342001,
    high: 410000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Five,
    partD: IRMAA_PART_D_SURCHARGE.Five,
    low: 410001,
    high: 749999,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Six,
    partD: IRMAA_PART_D_SURCHARGE.Six,
    low: 750000,
    high: 999999999,
  },
];

// IRMAA income tiers
export const MarriedSeparatelyTiers: CostTier[] = [
  {
    cost: IRMAA_PART_B_PREMIUM.One,
    partD: IRMAA_PART_D_SURCHARGE.One,
    low: 0,
    high: 109000,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Five,
    partD: IRMAA_PART_D_SURCHARGE.Five,
    low: 109001,
    high: 390999,
  },
  {
    cost: IRMAA_PART_B_PREMIUM.Six,
    partD: IRMAA_PART_D_SURCHARGE.Six,
    low: 391000,
    high: 999999999,
  },
];

export const PART_D_DRUG_OOPM = {
  2026: 2100,
};
